import { DetailsStore } from './details';
import { Payment } from './payments';

const paymentsStore = new Payment();
const detailsStore = new DetailsStore();

export * from './payments';
export * from './details';
export { paymentsStore, detailsStore };
